import React, {Component} from 'react';
import locales_es from "../../locales/es";
import Spinner from "../spinner";
import Button from "./button";
import APIService from "../../modules/apiService";
import Helpers from "../../modules/helpers";

export default class AppointmentScheduled extends Component {

  constructor(props) {
    super(props);

    this.state = {
      bankTransferData: null,
      countdown: null,
      countdownExpired: false,
    };
    this.timerInterval = null;

    this.api = new APIService();
    this.helpers = new Helpers();
  }

  componentDidMount() {
    const {selectedAppointment} = this.props;
    if (selectedAppointment?.requires_payment) {
      this.startCountdown();
    }
  }

  componentWillUnmount() {
    if (this.timerInterval) clearInterval(this.timerInterval);
  }

  startCountdown = () => {
    const {selectedAppointment} = this.props;
    const deadline = new Date(selectedAppointment.created_at).getTime() + 15 * 60 * 1000;

    this.timerInterval = setInterval(() => {
      const now = Date.now();
      const distance = deadline - now;

      if (distance <= 0) {
        clearInterval(this.timerInterval);
        this.setState({countdown: '00:00', countdownExpired: true});
      } else {
        const minutes = Math.floor(distance / 1000 / 60);
        const seconds = Math.floor((distance / 1000) % 60);
        const formatted = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        this.setState({countdown: formatted});
      }
    }, 1000);
  };


  render() {
    const {selectedAppointment, paymentMethods, onContinue, onBankTransferClick, onExternalCheckoutClick} = this.props;

    return (
      <>
        <div className="woopi-overlay">
          <div className="woopi-overlay-content">
            <div className="row justify-content-center">
              <div className="col-lg-9 text-center">
                <h4 className="m-4">{locales_es.appointmentScheduled.title}</h4>
                <div className="kt-timeline__item kt-timeline__item--warning">
                  {!selectedAppointment?.requires_payment
                    && <>
                  <span className="btn btn-warning btn-elevate btn-circle btn-icon mr-3">
                    <i className="flaticon-signs-2"></i>
                  </span><span
                      className="kt-timeline__item-datetime"><strong>{locales_es.important}: </strong>{locales_es.appointmentScheduled.text1}</span>
                    <br/>
                    <br/>
                    </>}
                  <div className="kt-timeline__item-text">
                    <strong>{selectedAppointment?.requires_payment ? locales_es.appointmentScheduled.requiresPaymentText : locales_es.appointmentScheduled.text2}</strong>.
                    {selectedAppointment?.requires_payment && this.state.countdown && (
                      <>
                        <br/>
                        <br/>
                        <div className="text-center mb-3">
                          <div class="alert alert-outline-focus fade show" role="alert">
                            <div class="alert-text">Tiempo restante para realizar el pago: <div
                              style={{fontSize: '1.5rem', marginTop: 5}}>{this.state.countdown}</div>
                              {this.state.countdownExpired && (
                                <div className="text-danger mt-2">⚠️ El tiempo para pagar ha expirado.</div>
                              )}</div>
                          </div>
                        </div>
                      </>
                    )}
                    {locales_es.appointmentScheduled.text3}:
                  </div>
                </div>
              </div>
            </div>
            <div className="row justify-content-center mt-3">
              <div className="col-lg-9 text-center">
                {paymentMethods ? paymentMethods.length ?
                    paymentMethods.map((pm, index) => <Button key={'button-' + index} paymentMethod={pm}
                                                              onContinue={onContinue}
                                                              onBankTransferClick={onBankTransferClick}
                                                              onExternalCheckoutClick={onExternalCheckoutClick}>{locales_es.gatewayMethodsList[pm.tag].label_patient}</Button>)
                    : <div>{locales_es.genericErrorContactSiteAdministrator}</div>
                  : <Spinner/>
                }
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
